import React from "react"

import { useTranslation } from "@bounce/i18n"
import type { ImgixParams } from "@bounce/web-components"
import { Button, Link, PostSlider } from "@bounce/web-components"

import { useSectionViewed } from "@/hooks/useSectionViewed"
import type { FormattedEvent } from "@/libs/prismic/event/types"
import { eventToPostCard } from "@/utils/event"

export type EventSuggestionsProps = {
  cityName?: string
  citySlug?: string
  events: FormattedEvent[]
  title: string
  className?: string
  imgixParams?: ImgixParams
}

export const EventSuggestions = ({
  events,
  title,
  cityName,
  citySlug,
  className,
  imgixParams,
}: EventSuggestionsProps) => {
  const { sectionRef } = useSectionViewed({ name: "Events" })
  const { t } = useTranslation("marketing-ls-city")

  if (!events.length) return null

  const transformedEvents = events.map(eventToPostCard)

  return (
    <PostSlider
      items={transformedEvents}
      sliderTitle={title}
      imgixParams={imgixParams}
      sectionRef={sectionRef}
      className={className}
      footer={
        !!cityName &&
        !!citySlug && (
          <Button as={Link} className="whitespace-normal !p-0 text-left" href={`/events/${citySlug}`} variant="ghost">
            {t("screen.cityNextScreen.eventSuggestions.seeAllCityEvents", "See all {{cityName}} events", {
              cityName,
            })}
          </Button>
        )
      }
    />
  )
}
